module.exports = __webpack_public_path__ + "img/電気回路_2_1_1.8c488184.png";